import { Box, BoxProps, useTheme } from '@mui/material';
import { type PropsWithChildren } from 'react';

const MAX_WIDTH = 1808;

export const StyledPageTabContent = ({ children, sx }: PropsWithChildren<Partial<BoxProps>>) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        width: '100%',
        height: '100%',
        overflowX: 'visible',
        padding: theme.spacing(2),
        gap: theme.spacing(10),
        maxWidth: MAX_WIDTH,
        // Callers may override the layout (the gen-3 Results tab left-aligns
        // content at the page gutter per the M4 visual audit), so the sx
        // spread must come last.
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
